var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container boxWithBorder"},[_c('ItineraryPieceBooking',{key:_vm.solutionAll.flight.key + _vm.solutionAll.hotel.key + _vm.solutionAll.car.key,staticClass:"ml-5 mr-5",attrs:{"sol":_vm.solutionAll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }